module.exports = __webpack_public_path__ + "1ecf27b6b3354f40a0733ee72fe49611.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/assignment.png
// module id = 1726
// module chunks = 0